.root {
  display: flex;
  flex-direction: column;
  background-color: var(--static-background-standard);
  border-radius: 0.75rem;
  border: 1px solid var(--static-divider-standard);
  overflow: hidden;
}

.header {
  padding: 1.8rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--static-divider-standard);
}

.table {
  width: 100%;
  background-color: var(--static-background-standard);
  border-radius: 10px;
  border-collapse: collapse;
}

.thead {
  height: 4rem;
}

.tr {
  border-bottom: 1px solid var(--static-divider-standard);
  height: 4rem;
  margin-left: 5px;
}
.tr:last-child {
  border-bottom: 0px;
}

.th {
  border-bottom: 1px solid var(--static-divider-standard);
  text-align: left;
  vertical-align: middle;
}

.shipmentNameContainer {
  margin-left: 30px;
  margin-top: 3px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}

.shipmentName {
  margin-left: 30px;
}

.shipmentNameCell {
  display: inline-block;
  max-width: 20rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shipmentCreatedAt {
  color: var(--static-text-weak);
  font-size: var(--fs-small-text);
}

.percentageReceivedContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.percentageReceivedText {
  color: var(--sentiment-text-positive);
}

.percentageReceivedLoader {
  background-color: var(--sentiment-text-positive);
  height: 5px;
  border-radius: 6px;
  margin-left: 10px;
}

.loaderContainer {
  margin: 30px;
}